import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* uniqueAssignmentName({ payload: { values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.uniqueName, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.uniqueAssignmentNameDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.uniqueAssignmentNameFailed,
      handledErrors,
      endpoint: api.modifiers.assignments.uniqueName.url
    });
  }
}

export const uniqueAssignmentNameSaga = takeEvery(types.UNIQUE_ASSIGNMENT_NAME_REQUEST, uniqueAssignmentName);